import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { PrintDeck } from "./components/PrintDeck";
import { DownloadPdfButton } from "./components/DownloadPdfButton";
import { DeckNav } from "./components/DeckNav";
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<>
      <div className="screen-only" data-id="element-114" data-mp="2aavv3rze56cv">
        <App data-id="element-115" data-mp="2abnnyv1lspzg" />
      </div>
      <PrintDeck data-id="element-116" data-mp="2aaclqznt3qag" />
      <DeckNav data-id="element-117" data-mp="2a8t69b9z5j9q" />
      <DownloadPdfButton data-id="element-118" data-mp="2f9yzrbbglakb" />
    </>);
}